<template>
  <div class="main-container flex flex-center">
    <div class="main-box" style="overflow: hidden">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="getTable(1)"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="getTable(2)"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 3 }"
            @click="getTable(3)"
            >{{ $t("m.options.listTab.star") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 4 }"
            @click="getTable(4)"
            >{{ $t("m.options.listTab.machine") }}</span
          >
        </div>
        <div class="box-header-right">
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            @click="importReportDialog = true"
          >
            {{ $t("m.chart.btn.newImport") }}</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="active-icon"
            @click="dialogTableVisible = true"
          ></el-button>
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 55px);">
        <div class="box-content">
          <div
              @click="checkDevice(item)"
              :class="[
            item.id == activeCurveId
              ? 'box-item box-half box-active'
              : 'box-item box-half',
          ]"
              v-for="item in reportList"
              v-bind:key="item.id"
          >
            <!--<div class="box-state box-state-1"></div>-->
            <div class="box-item-img">
              <img src="../../assets/img/编组18@2x.png" />
              <div class="datetime">
                <el-rate
                    :colors="['#FC9153', '#FC9153', '#FC9153']"
                    v-model="item.score"
                ></el-rate>
              </div>
            </div>
            <div class="box-item-text">
              <div>
              <span class="text-title">{{ $t("m.chart.table.name") }}：</span
              ><span class="text-value">{{ item.name }}</span>
              </div>
              <div>
              <span class="text-title"
              >{{ $t("m.chart.table.duration") }}：</span
              ><span class="text-value">{{
                timeFormatter(item.duration)
                }}</span>
              </div>
              <div>
              <span class="text-title"
              >{{ $t("m.chart.table.machineName") }}：</span
              ><span class="text-value">{{
                  item.deviceId == null
                      ? "无"
                      : item.deviceId
                }}</span>
              </div>
              <div>
              <span class="text-title">{{ $t("m.chart.table.date") }}：</span
              ><span class="text-value">{{
                  $moment(Number(item.createtime)).format("YYYY-MM-DD")
                }}</span>
              </div>
            </div>
          </div>

        </div>
        <div class="table-footer">
          <el-pagination
              v-show="reportPage.total > 0"
              background
              align="right"
              layout="prev, pager, next"
              @current-change="curvePageChange"
              :page-size="reportPage.pageSize"
              :total="reportPage.total"
          >
          </el-pagination>
        </div>
      </div>

    </div>
    <div class="main-box border-1px-all">
      <report-chart
        @finish="reportDetailLoadingFinish"
        :report-id="activeCurveId"
        :key="activeCurveId"
        :not-showuser="notShowuser"
        :url="fileUrl"
        @curve-deleted="handleCurveDeleted"
      ></report-chart>
    </div>
    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <el-input
            v-model="searchParamValue"
            :placeholder="$t('m.chart.table.placeholder1')"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="getTable" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
    <!--------导入弹框---------->
    <el-dialog
      :title="$t('m.chart.table.curveImport')"
      center
      :modal-append-to-body="false"
      :visible.sync="importReportDialog"
    >
      <el-row>
        <el-form :inline="true">
          <el-col :span="12">
            <el-form-item :label="$t('m.chart.table.label1')">
              <el-input
                v-model="addReportForm.name"
                clearable
                :placeholder="$t('m.chart.table.placeholder1')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('m.chart.table.label2')">
              <el-input
                v-model="addReportForm.note"
                clearable
                :placeholder="$t('m.chart.table.placeholder2')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <el-upload
          ref="reportFileUpload"
          name="reportFileUpload"
          accept=".json"
          :on-change="fileChange"
          :multiple="false"
          :auto-upload="false"
        >
          <el-button slot="trigger" size="small" type="primary">{{
            $t("m.chart.table.select")
          }}</el-button>
        </el-upload>
        {{ $t("m.chart.table.uploadTip") }}
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importReportDialog = false">{{
          $t("m.chart.table.back")
        }}</el-button>
        <el-button type="primary" @click="importReport">{{
          $t("m.chart.table.add")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import report from "@/components-online/curve/report";
var jsonFileStr = "";

export default {
  name: "curveList",
  components: {
    "report-chart": report,
  },
  data() {
    return {
      reportPage: {
        total: 0,
        pageSize: 50,
        pageNum: 1,
      },
      reportList: [],
      reportDetailDialog: false,
      reportKey: 0,
      selectReportId: 0,
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      url: "/manage/curve/union/list/ex",
      searchUrl: {
        trainUrl: "/manage/report/getOnlyListTrainByUser.do",
        manuUrl: "/manage/report/getOnlyListManuByUser.do",
        importUrl: "/manage/report/getOnlyListImportByUser.do",
        searchByNameUrl: "/manage/report/searchByName.do",
      },
      searchParamValue: "", //搜索框输入的值
      selectReportIds: [],
      importShow: 0,
      loading: undefined,
      importReportDialog: false,
      addReportForm: {
        name: "",
        note: "",
      },
      importReportInfo: "",
      selectSuitId: 0,
      reportCommentList: [],
      reportCommentPage: {
        pageSize: 100,
        pageNum: 1,
        total: 0,
      },
      selectCommentId: 0,
      importFileJson: {},
      activeCurveId: 0,

      active1: 1,
      star: 2,
      dialogTableVisible: false,
      notShowuser: false,
      fileUrl: ''
    };
  },
  mounted() {
    //this.loadReportList()
    if (localStorage.role != 1) {
      this.notShowuser = true;
    }
    this.getTable(1);
  },
  watch: {
    $route(to) {
      if (to.path === "on-curveList") {
        this.getTable(1);
      }
    },
  },
  methods: {
    getTable(tab) {
      let type = 'time';
      let active = 1;
      if (tab == 1) {
        type = 'time';
        active = 1;
      } else if (tab == 2) {
        type = 'name';
        active = 2;
      } else if (tab == 3) {
        type = 'level';
        active = 3;
      } else if (tab == 4) {
        type = 'count';
        active = 4;
      }
      this.active1 = active;
      this.importShow = 0;
      const params = {
        pageNum: this.reportPage.pageNum,
        pageSize: this.reportPage.pageSize,
        name: this.searchParamValue,
        sortField: type,
        collect: true
      }
      this.$http.post(this.url, params).then(resp => {
        this.reportList = resp.data.data.list;
        this.reportPage.total = resp.data.data.total;
        resp.data.data.list.length && (this.activeCurveId = resp.data.data.list[0].id);
        this.fileUrl = resp.data.data.list?.[0]?.fileUrl ?? `https://hb-coffee-image.oss-cn-hangzhou.aliyuncs.com/cf_data/${resp.data.data.list[0].userId}/${resp.data.data.list[0].note}` ?? null;

        if (this.dialogTableVisible) {
          this.dialogTableVisible = false;
        }
        this
      }).catch((err) => {
          console.info(err);
        });
    },
    searchByName() {
      this.getTable(this.active1);
    },
    checkDevice(item) {
      this.activeCurveId = item.id;
      this.fileUrl = item.fileUrl ?? `https://hb-coffee-image.oss-cn-hangzhou.aliyuncs.com/cf_data/${item.userId}/${item.note}` ?? null; 
    },
    reportDetailLoadingFinish() {
      //this.loading.close()
    },
    importReport() {
      let url =
        "/manage/report/importReportMulti.do?name=" +
        this.addReportForm.name +
        "&note=" +
        this.addReportForm.note;
      this.$http.defaults.withCredentials = true;
      console.info("添加的数据" + this.importReportInfo);
      console.info("添加的数据" + this.importFileJson);
      console.info("添加的数据" + jsonFileStr);
      this.$http
        .post(url, jsonFileStr)
        .then(
          function(response) {
            if (response.data.success) {
              this.$message.success(this.$t("m.alert.updateSuccess"));
              this.importReportDialog = false;
              this.loadReportList();
            } else {
              this.$message.error(response.data.msg);
            }
            this.addReportForm.name = "";
            this.addReportForm.note = "";
            this.$refs.reportFileUpload.clearFiles();
          }.bind(this)
        )
        .catch((err) => err);
    },
    fileChange(file, fileList) {
      console.info(file);
      console.info(fileList);
      // var selectedFile = document.getElementById("files").files[0];//获取读取的File对象
      let reader = new FileReader(); //这里是核心！！！读取操作就是由它完成的。
      reader.readAsText(file.raw); //读取文件的内容
      reader.onload = function() {
        // console.log("读取结果：", this.result);//当读取完成之后会回调这个函数，然后此时文件的内容存储到了result中。直接操作即可。
        this.importReportInfo = JSON.parse(this.result);
        this.importFileJson = JSON.parse(this.result);
        jsonFileStr = JSON.parse(this.result);
        console.info(this.importReportInfo);
        console.info(this.importFileJson);
      };
    },

    curvePageChange(val) {
      this.reportPage.pageNum = val;
      this.getTable(this.active1);
    },

    downFileLoad() {
      this.reportList
    },
    handleCurveDeleted(reportId) {
      console.log('Curve deleted:', reportId);
      this.getTable(1);
    },
    timeFormatter(value) {
      const minutes = Math.floor(value / 60);
      const secs = value % 60;
      const paddedMinutes = String(minutes).padStart(2, '0');
      const paddedSeconds = String(secs).padStart(2, '0');
      return `${paddedMinutes}:${paddedSeconds}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.table-footer {
  position: sticky;
  bottom: 0;
  background: #1a1b1c29;
  padding-top: 10px;
}
</style>
